import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, useState, createElement as _createElement } from 'react';
import { ChevronLeftSVG, ChevronRightSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { Carousel } from '@snack-uikit/carousel';
import { FieldDecorator } from '@snack-uikit/fields';
import { PaginationSlider } from '@snack-uikit/pagination';
import { ToggleGroup } from '@snack-uikit/toggles';
import { useAdaptive } from '../../../hooks';
import { parseKeyToDataTest } from '../../../utils';
import { ToggleCard } from '../ToggleCard';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CarouselControlUi(_ref) {
  var _ref2, _relatedUiProps$visib;
  var itemsProp = _ref.items,
    value = _ref.value,
    onChange = _ref.onChange,
    uiProps = _ref.uiProps,
    decoratorProps = _ref.decoratorProps,
    watchedValues = _ref.watchedValues,
    relateFn = _ref.relateFn,
    accessorKey = _ref.accessorKey;
  var _useAdaptive = useAdaptive(),
    isMobile = _useAdaptive.isMobile;
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedItems = _useMemo.items,
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var items = useMemo(function () {
    return relatedItems !== null && relatedItems !== void 0 ? relatedItems : itemsProp;
  }, [itemsProp, relatedItems]);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var maxPage = isMobile ? items.length : items.length - 1;
  var dataTestAttribute = parseKeyToDataTest('carousel', accessorKey);
  var navigationDataTestAttribute = parseKeyToDataTest('carousel-navigation');
  useEffect(function () {
    var pageIndex = items.findIndex(function (item) {
      return String(item.value) === String(value);
    });
    if (pageIndex !== -1) {
      var itemPage = isMobile ? pageIndex : Math.max(pageIndex - 1, 0);
      var timeout = setTimeout(function () {
        setPage(itemPage);
      }, 0);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [isMobile, items, value]);
  useEffect(function () {
    var pageIndex = items.findIndex(function (item) {
      return String(item.value) === String(value);
    });
    if (page > maxPage + 1) {
      setPage(pageIndex);
    }
  }, [value, onChange, items, page, maxPage]);
  var decPage = function decPage() {
    setPage(function (page) {
      return Math.max(0, page - 1);
    });
  };
  var incPage = function incPage() {
    setPage(function (page) {
      return Math.min(page + 1, Math.max(maxPage - 1, 0));
    });
  };
  useEffect(function () {
    if (!items.find(function (item) {
      return String(item.value) === String(value);
    })) {
      var _items$;
      onChange === null || onChange === void 0 ? void 0 : onChange(String(items === null || items === void 0 ? void 0 : (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.value));
      setPage(0);
    }
  }, [value, onChange, items, relatedItems]);
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.carousel,
    children: /*#__PURE__*/_jsxs(FieldDecorator, _objectSpread(_objectSpread(_objectSpread({
      size: "m",
      caption: maxPage > 1 ? /*#__PURE__*/_jsxs("div", {
        className: styles.controls,
        children: [/*#__PURE__*/_jsx(ButtonFunction, {
          icon: /*#__PURE__*/_jsx(ChevronLeftSVG, {}),
          size: "s",
          onClick: decPage,
          "data-test-id": "".concat(navigationDataTestAttribute, "-button-left")
        }), /*#__PURE__*/_jsx(ButtonFunction, {
          icon: /*#__PURE__*/_jsx(ChevronRightSVG, {}),
          size: "s",
          onClick: incPage,
          "data-test-id": "".concat(navigationDataTestAttribute, "-button-right")
        })]
      }) : undefined
    }, decoratorProps), relatedDecoratorProps), {}, {
      "data-test-id": dataTestAttribute,
      children: [/*#__PURE__*/_jsx(ToggleGroup, {
        selectionMode: "single",
        value: value,
        onChange: function (_onChange) {
          function onChange(_x) {
            return _onChange.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange.toString();
          };
          return onChange;
        }(function (value) {
          value && (onChange === null || onChange === void 0 ? void 0 : onChange(value));
        }),
        children: /*#__PURE__*/_jsx(Carousel, _objectSpread(_objectSpread({
          pagination: false,
          arrows: false
        }, uiProps), {}, {
          scrollBy: 1,
          swipe: true,
          infiniteScroll: false,
          showItems: isMobile ? 1.1 : 2.1,
          state: {
            page: page || 0,
            onChange: function onChange(page) {
              return setPage(page % maxPage);
            }
          },
          children: items.map(function (item) {
            return /*#__PURE__*/_createElement(ToggleCard, _objectSpread(_objectSpread({}, item), {}, {
              key: item.value
            }));
          })
        }))
      }), /*#__PURE__*/_jsx("div", {
        className: styles.pagination,
        children: maxPage > 1 && /*#__PURE__*/_jsx(PaginationSlider, {
          page: page + 1,
          total: maxPage,
          onChange: function onChange(page) {
            return setPage(page - 1);
          }
        })
      })]
    }))
  });
}